export default {
  "titles": {
    "editProfile": "Editar perfil"
  },
  "detail": {
    "email": "Mail (username)",
    "permits": "Permisos",
    "categories": "Categorías",
    "isAdmin": "Administrador - Todos los permisos",
    "editData": "Editar datos",
    "linkToWearable": "Pulseras de sueño",
    "resetPassword": "Reestablecer contraseña",
    "linkToFitbit": "Conectar Fitbit",
    "unLinkToFitbit": "Desconectar Fitbit",
    "fitbitState": "Estado Fitbit",
    "connect": "Conectado",
    "disconnect": "Desconectado",
    "tours": "Tours",
    "resetTours": "Reestablecer tours"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/user_profile/index.js